'use strict';

const selectors = {
    productIDs: '.js-product-ids'
};

/**
 * @private getActiveProductIDs
 * @param {Array} advice - An array of advice objects
 * @returns {Array} activeProductIDs - Returns an Array of all active product ID's
 */
function getActiveProductIDs(advice) {
    const activeProducts = advice
        .flatMap((categories) => {
            return categories.products.flatMap((product) => {
                if (product.recommended === true) {
                    return product.id;
                }
                return false;
            });
        })
        .filter((productID) => !!productID);

    return [...new Set(activeProducts)];
}
/**
 * @function setActiveProductIDs
 * @private
 * @param {Array} advice - An array of advice objects
 * @param {HTMLElement} [container=document] - The container in which to search for the productIDs element
 * @description This function sets the active product IDs in the provided container. If no container is provided, it defaults to the document.
 */
function setActiveProductIDs(advice, container = document) {
    const productIDs = container.querySelectorAll(selectors.productIDs);
    const activeProductIDs = getActiveProductIDs(advice).join();

    productIDs.forEach((field) => {
        field.value = activeProductIDs;
    });
}

export { setActiveProductIDs };
